import {HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest} from "@angular/common/http";
import {inject} from "@angular/core";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {AlertDialogService} from '../dialog/alert-dialog/alert-dialog.service';

export const IGNORE_422_ERROR = new HttpContextToken<boolean>(() => false);

export function http422Interceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  const alertDialogService = inject(AlertDialogService);

  if (req.context.get(IGNORE_422_ERROR)) {
    return next(req)
  }
  return next(req).pipe(tap(event => {
  }, err => {
    // Let the request subscriber settle its view state (for example, reset a
    // submit button) before NgbModal starts a nested change-detection pass.
    queueMicrotask(() => handleError(err, alertDialogService, req.url));
  }));
}

function handleError(err: HttpErrorResponse, alertDialogService: AlertDialogService, requestUrl: string) {
  if (err.status === 422) {
    const message = err.error?.message;
    alertDialogService.open({
      type: 'warning',
      isInnerHTML: true,
      title: 'แจ้งเตือน',
      content: `<div class="text-center">
                    <div class="fw-semibold text-muted mb-2">ไม่สามารถดำเนินการได้</div>
                    <div>${message ?? ''}</div>
                </div>`,
      confirmButtonMsg: 'ปิด'
    });
    return;
  }
  // A revoked/expired grant surfaces as a 403 with no server-provided message.
  // The ownership FORBIDDEN does carry a message, so it is left untouched here.
  if (err.status === 403 && requestUrl.includes('/api/trade-records') && !err.error?.message) {
    alertDialogService.open({
      type: 'warning',
      isInnerHTML: true,
      title: 'แจ้งเตือน',
      content: `<div class="text-center">
                    <div class="fw-semibold text-muted mb-2">สิทธิ์ของคุณถูกยกเลิก</div>
                    <div>กรุณาติดต่อผู้มอบสิทธิ์เพื่อขอสิทธิ์ใหม่</div>
                </div>`,
      confirmButtonMsg: 'ปิด'
    });
  }
}
